import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KLayout, KDemo } from "@/pages/kreonis/KLayout";
import { Seo } from "@/components/Seo";

const expo = (d) => d?.startsWith("BUY") ? "LONG EXPOSURE" : d?.startsWith("SELL") ? "SHORT EXPOSURE" : "NEUTRAL (WAIT)";
const expoCls = (d) => d?.startsWith("BUY") ? "text-emerald-400" : d?.startsWith("SELL") ? "text-rose-400" : "text-amber-400";

export default function KIntelligence() {
  const [signals, setSignals] = useState([]);
  const [an, setAn] = useState(null);
  useEffect(() => {
    api.get("/signals?limit=24&min_confidence=50").then((r) => setSignals(r.data.signals)).catch(() => {});
    api.get("/signals/analytics").then((r) => setAn(r.data)).catch(() => {});
  }, []);
  return (
    <KLayout>
      <Seo title="KREONIS — Predictive Signals & Alpha Feed" />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <div className="flex items-center justify-between"><div><h1 className="font-display text-3xl font-bold text-slate-50">Intel Feed — Predictive Signals</h1><p className="mt-2 text-slate-400">High-fidelity, non-correlated market exposure signals with full analytical synthesis.</p></div><KDemo /></div>
        {an && (
          <div className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-6" data-testid="kintel-analytics">
            {[["Signals", an.total_signals], ["Long/Short Wins", an.wins], ["Losses", an.losses], ["Hit Rate", `${an.win_rate}%`], ["Avg R/R", an.avg_rr], ["Max DD", `${an.max_drawdown}R`]].map(([l, v]) => (
              <div key={l} className="rounded-xl border border-slate-800 bg-slate-900/50 p-4"><div className="text-[10px] uppercase tracking-wider text-slate-500">{l}</div><div className="mt-1 font-display text-xl font-bold text-slate-100">{v}</div></div>
            ))}
          </div>
        )}
        <div className="mt-8 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {signals.map((s, i) => (
            <div key={i} className="rounded-2xl border border-slate-800 bg-slate-900/50 p-5" data-testid={`kintel-card-${i}`}>
              <div className="flex items-start justify-between">
                <div><div className="font-display text-lg font-bold text-slate-100">{s.asset}</div><div className="text-xs capitalize text-slate-500">{s.market} · {s.timeframe}</div></div>
                <div className={`font-display text-sm font-bold ${expoCls(s.direction)}`}>{expo(s.direction)}</div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-slate-300">
                <Row l="Entry Range" v={`${s.entry_low}–${s.entry_high}`} />
                <Row l="R/R" v={s.risk_reward} />
                <Row l="Invalidation" v={s.stop_loss} />
                <Row l="Target 1" v={s.tp1} />
                <Row l="Horizon" v={s.timeframe} />
                <Row l="Target 2" v={s.tp2} />
              </div>
              <div className="mt-3">
                <div className="flex justify-between text-xs text-slate-500"><span>Confidence Score</span><span className="font-mono">{s.confidence}/100</span></div>
                <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-slate-800"><div className="h-full bg-emerald-500" style={{ width: `${s.confidence}%` }} /></div>
              </div>
              <div className="mt-3 rounded-lg border border-slate-800 bg-slate-950/50 p-3">
                <div className="text-[10px] font-semibold uppercase tracking-wider text-emerald-400">AI Analytical Synthesis</div>
                <p className="mt-1 line-clamp-4 text-xs leading-relaxed text-slate-400">{s.explanation}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-xs text-slate-600">KREONIS provides probabilistic market intelligence for informational purposes. Not a guarantee of performance; not personalized financial advice.</p>
      </div>
    </KLayout>
  );
}
function Row({ l, v }) { return <div className="flex justify-between"><span className="text-slate-500">{l}</span><span className="font-mono">{v}</span></div>; }
